import React, { useMemo } from "react";
import EChart from "./EChart";
import { ECHART_TOOLTIP, ECHART_TOOLBOX, getColorForLabel } from "../../Utilities/echartsTheme";
import { formatNumber } from "../../Utilities/numbers";

const EChartsHorizontalBar = ({ data, label = "Value", titleText = "", multiColor = false, color }) => {
  const option = useMemo(() => {
    const items = (data || []).slice().sort((a, b) => b.value - a.value);
    const labels = items.map((d) => d.label);
    const values = items.map((d) => Number(d.value) || 0);
    const colors = items.map((d, i) =>
      multiColor ? getColorForLabel(d.label, i) : (color || getColorForLabel(d.label, i))
    );

    return {
      tooltip: {
        ...ECHART_TOOLTIP,
        trigger: "axis",
        axisPointer: { type: "shadow" },
        formatter: (params) => {
          const p = params[0];
          return `<div style="font-weight:600;margin-bottom:4px">${p.name}</div>${label}: ${formatNumber(p.value)}`;
        },
      },
      toolbox: ECHART_TOOLBOX,
      grid: { left: "3%", right: "5%", bottom: "3%", top: "8%", containLabel: true },
      xAxis: {
        type: "value",
        axisLabel: { formatter: (v) => formatNumber(v) },
      },
      yAxis: {
        type: "category",
        data: labels,
        axisLabel: {
          width: 120,
          overflow: "truncate",
          fontSize: 11,
        },
      },
      series: [
        {
          type: "bar",
          data: values.map((v, i) => ({
            value: v,
            itemStyle: { color: colors[i], borderRadius: [0, 4, 4, 0] },
          })),
          barMaxWidth: 28,
          label: {
            show: true,
            position: "right",
            formatter: (p) => formatNumber(p.value),
            fontSize: 11,
            color: "#64748B",
          },
          animationDelay: (idx) => idx * 50,
        },
      ],
    };
  }, [data, label, multiColor, color]);

  return <EChart option={option} />;
};

export default EChartsHorizontalBar;
